import React from 'react';
import Svg, { Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';
import PropTypes from 'prop-types';
import { PALETTE } from '../../../constants';

const WarningDarkIcon = (props) => {
  const {
    color,
    ...svgProps
  } = props;
  return(
    <Svg {...svgProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 5.37273 5.37273 0 12 0C18.6273 0 24 5.37273 24 12C24 18.6273 18.6273 24 12 24C5.37273 24 0 18.6273 0 12ZM10.909 18.5455C10.909 17.9122 11.371 17.4545 11.9999 17.4545C12.6653 17.4545 13.0908 17.9122 13.0908 18.5455C13.0908 19.1613 12.6653 19.6364 11.9999 19.6364C11.353 19.6364 10.909 19.1613 10.909 18.5455ZM11.4544 5.45564H12.5453C12.8972 5.45564 13.1012 5.60712 13.0908 5.92317L12.8126 14.6992C12.8023 15.0153 12.5055 15.2738 12.1537 15.2738H11.8455C11.4937 15.2738 11.1975 15.0153 11.1872 14.6992L10.909 5.92317C10.8986 5.60712 11.1026 5.45564 11.4544 5.45564Z" fill={color}/>
    </Svg>
  )
}

WarningDarkIcon.defaultProps = {
  height: 24,
  width: 24,
  color: PALETTE.warning,
};

WarningDarkIcon.PropTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
}

export default pure(WarningDarkIcon);